export const HOME_PATH = "/";
export const GAME_PATH = "/game";
export const ABOUT_PATH = "/about";
export const STATS_PATH = "/stats";
export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "/register";
